import type { SVGProps } from 'react';

/**
 * Instagram Collab Reel glyph — replicated verbatim from Figma's custom
 * "24 / People" icon component (node 575:10602, file
 * 0Vugg58oB0iBf1CxP0CUyp). Not a Phosphor icon — a two-person mark (matches
 * the "2 creators" sublabel). Uses `currentColor` to compose with the
 * white-on-gradient-tile treatment it sits in inside deliverable type cards.
 */
export function InstagramCollabReelIcon({
  size = 18,
  className,
  weight: _weight,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number; weight?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      className={className}
      {...props}
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M7.05898 4.7059C5.43461 4.7059 4.1178 6.02271 4.1178 7.64708C4.1178 9.27144 5.43461 10.5883 7.05898 10.5883C8.68334 10.5883 10.0002 9.27144 10.0002 7.64708C10.0002 6.02271 8.68334 4.7059 7.05898 4.7059ZM5.29427 7.64708C5.29427 6.67246 6.08436 5.88237 7.05898 5.88237C8.0336 5.88237 8.82368 6.67246 8.82368 7.64708C8.82368 8.6217 8.0336 9.41178 7.05898 9.41178C6.08436 9.41178 5.29427 8.6217 5.29427 7.64708Z" fill="currentColor" />
      <path d="M1.96094 15.0268C1.96094 12.9003 3.68476 11.1765 5.8112 11.1765L8.30675 11.1765C10.4332 11.1765 12.157 12.9003 12.157 15.0268V15.2407C12.157 15.5951 11.8697 15.8824 11.5153 15.8824C11.1609 15.8824 10.8736 15.5951 10.8736 15.2407V15.0268C10.8736 13.6091 9.72438 12.4599 8.30675 12.4599L5.8112 12.4599C4.39358 12.4599 3.24436 13.6091 3.24436 15.0268V15.2407C3.24436 15.5951 2.95706 15.8824 2.60265 15.8824C2.24824 15.8824 1.96094 15.5951 1.96094 15.2407V15.0268Z" fill="currentColor" />
      <path d="M10.3644 4.61239C10.688 4.19124 11.1948 3.92159 11.7649 3.92159C12.7395 3.92159 13.5296 4.71167 13.5296 5.68629C13.5296 6.66091 12.7395 7.451 11.7649 7.451C11.6944 7.451 11.6251 7.4469 11.5572 7.43896C11.2345 7.40127 10.9423 7.63229 10.9046 7.95497C10.8669 8.27765 11.098 8.56979 11.4206 8.60749C11.5338 8.6207 11.6486 8.62747 11.7649 8.62747C13.3892 8.62747 14.706 7.31066 14.706 5.68629C14.706 4.06193 13.3892 2.74512 11.7649 2.74512C10.8138 2.74512 9.96815 3.19712 9.43148 3.8956C9.23355 4.15321 9.28192 4.5225 9.53954 4.72044C9.79715 4.91838 10.1664 4.87 10.3644 4.61239Z" fill="currentColor" />
      <path d="M11.3727 9.60786L13.0127 9.60786C15.1391 9.60786 16.863 11.3317 16.863 13.4581V13.672C16.863 14.0264 16.5756 14.3137 16.2212 14.3137C15.8668 14.3137 15.5795 14.0264 15.5795 13.672V13.4581C15.5795 12.0405 14.4303 10.8913 13.0127 10.8913H11.3727C10.1963 10.8913 10.1963 9.60786 11.3727 9.60786Z" fill="currentColor" />
    </svg>
  );
}
